import { Box, Grid } from "@mui/material";
import { useGetBuyerAUMQuery } from "api/api-operations";
import NoData from "components/Common/NoData";
import SkeletonLoad from "components/Common/SkeletonLoad";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

function BuyerAUM() {
  const { data: buyerAUM, isFetching } = useGetBuyerAUMQuery(null);

  if (isFetching && !buyerAUM) {
    return <SkeletonLoad bars={10} />;
  }

  // Transform sorted stats into series data
  const seriesData = buyerAUM?.map((item) => ({
    name: item.buyer_name_for_report,
    y: Number(item.usd_daily_fx_invoice_amount) || 0,
  }));

  const total_usd_daily_fx_invoice_amount_all_invoices =
    (buyerAUM ?? [])?.reduce(
      (acc, curr) => acc + parseFloat(curr.usd_daily_fx_invoice_amount),
      0
    ) / 1000000;

  const screenWidth = window.innerWidth;

  // Define Highcharts options
  const options: Highcharts.Options = {
    chart: {
      type: "pie",
      height: 800,
    },
    title: {
      text: "AUM For Daily Report meeting by Buyer",
    },

    subtitle: {
      useHTML: true,
      //get sum of all AUM
      text: `$${total_usd_daily_fx_invoice_amount_all_invoices.toFixed(2)}M`,
      floating: true,
      align: "center",
      verticalAlign: "middle",
      style: {
        fontSize: screenWidth >= 1514 ? "3em" : "1rem",
        color: "black",
        fontWeight: "bold",
      },
      y: screenWidth >= 1514 ? -50 : -160,
    },
    plotOptions: {
      pie: {
        crisp: true,
        center: ["50%", "50%"],
        size: "75%",
      },
      series: {
        stacking: "normal",
        dataLabels: [
          {
            enabled: true,
            distance: 10,
            formatter: function () {
              return `
              <div>
              <span>${((this as any)?.y / 1000000).toFixed(2)}M</span>
              <span>(${(this as any)?.percentage.toFixed(2)}%)</span>
              </div>
              `;
            },
            style: {
              fontSize: "0.9em",
              color: "black",
            },
          },
        ] as any[], //cannot avoid this type assertion because of the prop 'distance'
        showInLegend: true,
      },
    },
    legend: {
      align: "center",
      layout: "horizontal",
      verticalAlign: "bottom",
      x: 100,
      width: 1300,
      itemWidth: 400,
      // itemMarginTop: 0,
      // itemMarginBottom: -2,
      maxHeight: 340,
      navigation: {
        enabled: true,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "AUM",
        colorByPoint: true,
        type: "pie",
        innerSize: "45%",
        data: seriesData,
      } as any, //cannot avoid this type assertion because of the prop 'innerSize'
    ],
  };

  return (
    <Box sx={{ display: "flex" }} flexGrow={1}>
      {isFetching && <SkeletonLoad bars={10} />}
      {!isFetching && !buyerAUM && (
        <NoData text="No daily AUM data to be displayed" />
      )}
      {!isFetching && buyerAUM && (
        <Grid container>
          <Grid item xs={12} id="aum-chart-container" margin="auto">
            {buyerAUM?.length === 0 && (
              <NoData text="No daily AUM data to be displayed" />
            )}
            {buyerAUM?.length > 0 && (
              <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate
                containerProps={{
                  className: "__aum_chart",
                  style: {
                    margin: "auto",
                  },
                }}
              />
            )}
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

export default BuyerAUM;
